const React = require('react');
const classNames = require('classnames');

const { HOME_TOPICS } = require('../../../lib/helpCenter/content');
const { getProductPath } = require('../../../lib/helpCenter/utilities');

const SetClientProps = require('../components/setClientProps');

const ProductLink = ({ children, product, requestContext, tdata }) => {
  const productPath = getProductPath({ product, requestContext });

  return (
    <a
      id={`product-${product.id}`}
      href={`${requestContext.protocol}:${requestContext.hostPath}/${productPath}${requestContext.qs}`}
      data-href={`${requestContext.hostPath}/${productPath}${requestContext.qs}`}
      data-bot={`${productPath}`}
      data-eid="mcx.help-center.home.product.click"
      data-tdata={tdata}
    >
      { children }
    </a>
  );
};

const TopicLink = ({ children, tdata, topic }) => {
  return (
    <a
      href={topic.url}
      data-href={topic.url}
      data-eid="mcx.help-center.home.topic.click"
      data-tdata={tdata}
    >
      { children }
    </a>
  );
};

const MoreProducts = ({ products, requestContext }) => (
  <React.Fragment>
    <h4 className="font-primary-bold">{ products[0].group }</h4>
    <ul className="list-unstyled">
      {
        products.map((product, index) => {
          return (
            <li key={product.id}>
              <ProductLink
                product={product}
                requestContext={requestContext}
                tdata={`item,${index + 1}^group,${product.group}^id,${product.strId}^name,${product.name}^plId,${requestContext.plId}`}
              >
                { product.name }
              </ProductLink>
            </li>
          );
        })
      }
    </ul>
  </React.Fragment>
);

const SeeAll = ({ messages, onClick }) => (
  <div className="home-browse-content-products-see-all">
    <span onClick={onClick}>{ messages['HelpCenter:Home:Browse:SeeAll']}&nbsp;<span className="uxicon uxicon-chevron-down-lt" /></span>
  </div>
);

const HideAll = ({ messages, onClick }) => (
  <div className="home-browse-content-products-see-all">
    <span onClick={onClick}>{ messages['HelpCenter:Home:Browse:HideAll']}&nbsp;<span className="uxicon uxicon-chevron-up-lt" /></span>
  </div>
);

class HomeBrowse extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickTab = this.handleClickTab.bind(this);
    this.handleProductsShow = this.handleProductsShow.bind(this);
    this.handleProductsHide = this.handleProductsHide.bind(this);

    this.state = {
      tab: 'product',
      show: false
    };
  }

  handleClickTab(activeTab) {
    this.setState({ tab: activeTab });

    window.ux.traffic.click(
      'mcx.help-center.home.browse.click',
      [
        ['type', activeTab],
        ['plId', this.props.requestContext.plId],
        ['market', this.props.requestContext.market]
      ]
    );
  }

  handleProductsShow() {
    this.setState({ show: true });
  }

  handleProductsHide() {
    this.setState({ show: false });
  }

  render() {
    const { cdnPath, messages, products, requestContext } = this.props;

    const productsFeatured = products.slice(0, 8);
    const productsRemainder = products.slice(8, products.length);

    const productRemainderGroups = {};
    productsRemainder.forEach(productRemainder => {
      productRemainderGroups[productRemainder.groupIdentifier]
        ? productRemainderGroups[productRemainder.groupIdentifier].push(productRemainder)
        : productRemainderGroups[productRemainder.groupIdentifier] = [productRemainder];
    });
    const productsDomainRelated = productRemainderGroups.DomainRelated;
    const productsHosting = productRemainderGroups.Hosting;
    const productsMarketing = productRemainderGroups.OnlineMarketing;
    const productsPartnerPrograms = productRemainderGroups.PartnerPrograms;
    const productsProductivity = productRemainderGroups.Productivity;
    const productsWebSecurity = productRemainderGroups.WebSecurity;
    const productsWebsites = productRemainderGroups.Websites;
    const productsLegacy = productRemainderGroups.Legacy;

    return (
      <React.Fragment>

        <div className="home-browse-container">

          <div className="home-browse-tabs">

            <div className="home-browse-tab" onClick={() => this.handleClickTab('product')} >
              <div className="home-browse-tab-title">{messages['HelpCenter:Home:Browse:Product']}</div>
              <div className={classNames('home-browse-tab-bar', this.state.tab === 'product' && 'active')} />
            </div>

            <div className="home-browse-tab" onClick={() => this.handleClickTab('topic')} >
              <div className="home-browse-tab-title">{messages['HelpCenter:Home:Browse:Topic']}</div>
              <div className={classNames('home-browse-tab-bar', this.state.tab === 'topic' && 'active')} />
            </div>

          </div>

          <div className="home-browse-content">

            { this.state.tab === 'product' &&
              <React.Fragment>

                <div className="home-browse-content-products hidden-sm-down">
                  <div className="home-browse-content-products-featured">
                    <div className="columns">
                      {
                        productsFeatured.map((product, index) => {
                          return (
                            <div className="home-browse-content-product-container column column-4 column-6 column-12" key={product.id}>
                              <ProductLink
                                product={product}
                                requestContext={requestContext}
                                tdata={`item,${index + 1}^id,${product.strId}^name,${product.name}^plId,${requestContext.plId}`}
                              >
                                <div className="home-browse-content-product">
                                  <div className="home-browse-content-product-image">
                                    <img src={`${cdnPath}/hc/${product.image}.svg`} alt={product.name} />
                                  </div>
                                  <div className="home-browse-content-product-bar" />
                                  <div className="home-browse-content-product-title">{ product.name }</div>
                                </div>
                              </ProductLink>
                            </div>
                          );
                        })
                      }
                    </div>
                  </div>

                  { !this.state.show && <SeeAll onClick={this.handleProductsShow} messages={messages} /> }

                  { this.state.show &&
                    <div className="home-browse-content-products-remainder">
                      <div className="columns">
                        { (productsDomainRelated || productsHosting) &&
                          <div className="column">
                            <MoreProducts products={productsDomainRelated} requestContext={requestContext} />
                            <MoreProducts products={productsHosting} requestContext={requestContext} />
                          </div>
                        }
                        { (productsMarketing || productsPartnerPrograms) &&
                          <div className="column">
                            <MoreProducts products={productsMarketing} requestContext={requestContext} />
                            <MoreProducts products={productsPartnerPrograms} requestContext={requestContext} />
                          </div>
                        }
                        { (productsProductivity || productsWebSecurity) &&
                          <div className="column">
                            <MoreProducts products={productsProductivity} requestContext={requestContext} />
                            <MoreProducts products={productsWebSecurity} requestContext={requestContext} />
                          </div>
                        }
                        { (productsWebsites || productsLegacy) &&
                          <div className="column">
                            <MoreProducts products={productsWebsites} requestContext={requestContext} />
                            <MoreProducts products={productsLegacy} requestContext={requestContext} />
                          </div>
                        }
                      </div>
                    </div>
                  }

                  { this.state.show && <HideAll onClick={this.handleProductsHide} messages={messages} /> }

                </div>

                <div className="home-browse-content-products hidden-md-up">
                  {
                    productsFeatured.map((product, index) => {
                      return (
                        <div className="home-browse-content-product-container-mobile" key={product.id}>
                          <ProductLink
                            product={product}
                            requestContext={requestContext}
                            tdata={`item,${index + 1}^id,${product.strId}^name,${product.name}^plId,${requestContext.plId}`}
                          >
                            <div className="home-browse-content-product-mobile">
                              <div className="home-browse-content-product-image-mobile">
                                <img src={`${cdnPath}/hc/${product.image}.svg`} alt={product.name} />
                              </div>
                              <h5 className="home-browse-content-product-title-mobile">{ product.name }</h5>
                            </div>
                          </ProductLink>
                        </div>
                      );
                    })
                  }

                  { !this.state.show && <SeeAll onClick={this.handleProductsShow} messages={messages} /> }

                  { this.state.show &&
                    productsRemainder.map((product, index) => {
                      return (
                        <div className="home-browse-content-product-container-mobile" key={product.id}>
                          <ProductLink
                            product={product}
                            requestContext={requestContext}
                            tdata={`item,${index + 1}^group,${product.group}^id,${product.strId}^name,${product.name}^plId,${requestContext.plId}`}
                          >
                            <div className="home-browse-content-product-mobile">
                              <div className="home-browse-content-product-image-mobile">
                                <img src={`${cdnPath}/hc/${product.image}.svg`} alt={product.name} />
                              </div>
                              <h5 className="home-browse-content-product-title-mobile">{ product.name }</h5>
                            </div>
                          </ProductLink>
                        </div>
                      );
                    })
                  }

                  { this.state.show && <HideAll onClick={this.handleProductsHide} messages={messages} /> }
                </div>

              </React.Fragment>
            }

            { this.state.tab === 'topic' &&
              <div className="columns">
                {
                  HOME_TOPICS.map((topic, index) => {
                    return (
                      <div className="home-browse-content-topic-container column column-4 column-6 column-12" key={index}>
                        <TopicLink
                          topic={topic}
                          tdata={`item,${index + 1}^title,${topic.title}^plId,${requestContext.plId}`}
                        >
                          <div className="home-browse-content-topic">
                            <div className="home-browse-content-topic-image">
                              <img src={`${cdnPath}/hc/topic_${index + 1}.jpg`} alt={topic.title} />
                            </div>
                            <div className="home-browse-content-topic-title">
                              { topic.title }
                            </div>
                          </div>
                        </TopicLink>
                      </div>
                    );
                  })
                }
              </div>
            }

          </div>

        </div>

        <SetClientProps component={this} />

      </React.Fragment>
    );
  }
}

HomeBrowse.clientName = 'HomeBrowse';

module.exports = HomeBrowse;
